import {
  CompanyDocumentTreeDataNode,
  CompanyDocumentTreeNode,
} from "../model/types";
import { isFolderNode } from "./tree-node-guards";
import { sortByTitle } from "@/shared/sorting";
import { nodeTitle } from "./node-title";

/** Папки идут выше файлов, внутри — по названию. */
function compareDataNodes(
  a: CompanyDocumentTreeDataNode,
  b: CompanyDocumentTreeDataNode,
): number {
  if (a.isFolder !== b.isFolder) {
    return a.isFolder ? -1 : 1;
  }

  return sortByTitle(a.title, b.title);
}

function sortDataNodes(nodes: CompanyDocumentTreeDataNode[]) {
  nodes.sort(compareDataNodes);

  for (const node of nodes) {
    if (node.children) {
      sortDataNodes(node.children);
    }
  }
}

export function treeNodesToDataNodes(
  nodes: CompanyDocumentTreeNode[],
  hiddenLabel: string,
): CompanyDocumentTreeDataNode[] {
  const dataNodeMap = new Map<string, CompanyDocumentTreeDataNode>();

  for (const node of nodes) {
    const isFolder = isFolderNode(node);
    dataNodeMap.set(node.id, {
      key: node.id,
      title: nodeTitle(node, hiddenLabel),
      isFolder,
      node,
    });
  }

  const roots: CompanyDocumentTreeDataNode[] = [];

  for (const node of nodes) {
    const dataNode = dataNodeMap.get(node.id)!;
    const parent = node.parentId ? dataNodeMap.get(node.parentId) : undefined;

    if (parent && parent.isFolder) {
      (parent.children ??= []).push(dataNode);
    } else {
      roots.push(dataNode);
    }
  }

  for (const dataNode of dataNodeMap.values()) {
    dataNode.isLeaf = !dataNode.children?.length;
  }

  sortDataNodes(roots);

  return roots;
}
